import { useEffect, useMemo, useState } from 'react';
import { IAccountDynamicsFilter } from '@pages/AccountsDynamics/List/filter';
import { useAccountDynamicsLine } from '@app/queries/account-dynamics/useAccountDymanicsLine';
import { halfOfYearLabelRange } from '@app/helpers/lineChartsHelper';
import { IAccountDynamicsLine } from '@entities/accountDynamics/IAccountDynamicsLine';

function useAccountDynamicsGraph(
  isNewOld: boolean,
  filters?: IAccountDynamicsFilter | null,
  search?: string | null
): [boolean, any] {
  const accountDynamicsLineFetcher = useAccountDynamicsLine();

  const [accountDynamicsLineData, setAccountDynamicsLineData] = useState<IAccountDynamicsLine[]>(
    []
  );

  useEffect(() => {
    (async () => {
      if (!filters) return;

      const data = await accountDynamicsLineFetcher.fetchData({
        ...filters,
        byType: !isNewOld,
        search: search,
      } as IAccountDynamicsFilter);

      setAccountDynamicsLineData(data);
    })();
  }, [filters, search, isNewOld]);

  const formatDynamicsGraph = (data: any, items: IAccountDynamicsLine[]) => {
    let currMonth = '';
    let isSkippedFirstIndicator = false;
    const monthForHalfOfYear = halfOfYearLabelRange(items);

    items.map((item, index) => {
      const [, month, year] = item.date.split('-');
      let label = null;

      if (null !== monthForHalfOfYear) {
        if (currMonth !== month && monthForHalfOfYear.includes(+month)) {
          label = month + '.' + year.slice(-2);
          currMonth = month;
        }
      } else {
        if (currMonth !== month) {
          label = month + '.' + year.slice(-2);
          currMonth = month;
        }
      }

      if (!isSkippedFirstIndicator && label) {
        label = null;
        isSkippedFirstIndicator = true;
      }

      // @ts-ignore
      data[item.date] = Object.assign(data[item.date] !== undefined ? data[item.date] : {}, {
        name: label,
        date: item.date,
        mining: item.mining,
        referral: item.referral,
      });
    });

    return data;
  };

  const graphData = useMemo(() => {
    let data: never[] = [];

    data = formatDynamicsGraph(data, accountDynamicsLineData);

    return Object.values(data);
  }, [accountDynamicsLineData]);

  const loading = !(accountDynamicsLineFetcher.isSuccess && accountDynamicsLineData !== null);

  return [loading, graphData];
}

export default useAccountDynamicsGraph;
